// extracted by mini-css-extract-plugin
var _1 = "pSvF8";
export { _1 as "buttonWarning" }
